"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var components_1 = require("../../components");
var chip_styles_css_1 = __importDefault(require("./chip.styles.css"));
var crossIcon_1 = require("./crossIcon");
var Chip = /** @class */ (function () {
    function Chip(text, isValidEmail, removeEntry) {
        var optionalProps = components_1.options.getProps();
        var themeChip = optionalProps.theme && optionalProps.theme.chip ? optionalProps.theme.chip : chip_styles_css_1.default.chip;
        var themeCross = optionalProps.theme && optionalProps.theme.cross ? optionalProps.theme.cross : chip_styles_css_1.default.cross;
        if (!isValidEmail) {
            var validTheme = optionalProps.theme && optionalProps.theme.chipInvalid ? optionalProps.theme.chipInvalid : chip_styles_css_1.default.chipInvalid;
            themeChip = themeChip + " " + validTheme;
            ;
        }
        this.ref = null;
        this.props = {
            text: text,
            removeEntry: removeEntry,
            themeChip: themeChip,
            themeCross: themeCross,
        };
        this.render();
    }
    Chip.prototype.createMarkup = function () {
        var props = this.props;
        var themeChip = props.themeChip, themeCross = props.themeCross, text = props.text;
        var el = document.createElement('div');
        var content = document.createTextNode(text);
        var icon = crossIcon_1.CrossIcon();
        el.setAttribute('class', themeChip);
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '-1');
        el.appendChild(content);
        // ie11 classList does not work on svg
        icon.setAttribute('class', themeCross);
        el.appendChild(icon);
        return { el: el, icon: icon };
    };
    Chip.prototype.render = function () {
        var markup = this.createMarkup();
        this.ref = markup.el;
        this.bindEvents(markup.icon);
    };
    Chip.prototype.bindEvents = function (target) {
        var _this = this;
        var props = this.props;
        var removeEntry = props.removeEntry;
        if (this.ref && removeEntry) {
            target.addEventListener('click', function () { return removeEntry(_this.ref); });
        }
    };
    return Chip;
}());
exports.Chip = Chip;
